<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="$l('dialog_title_choose_evg_combine_sku') || '选择组合产品'"
    show-close
    top="5vh"
    width="90%"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main ref="main" @change="(rows) => (checkedRows = rows)" />

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkedCount" class="ml-2">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { visible: { type: Boolean, default: false } },
  data() {
    return { checkedRows: [] }
  },
  computed: {
    checkedCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.checkedRows = []
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRows)
      this.close()
    },
  },
}
</script>
